import { ChangeDetectionStrategy, Component, input, output } from '@angular/core';
import { Card } from '@stripe/stripe-js';
import { ButtonDirective } from '../../../shared/directives/button.directive';

@Component({
  selector: 'app-checkout-existing-card',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ButtonDirective],
  templateUrl: './checkout-existing-card.component.html',
  styleUrl: './checkout-existing-card.component.scss',
})
export class CheckoutExistingCardComponent {
  card = input.required<Card>();
  update = output();
}
